import React from 'react';

interface SimpleInputProps {
  title: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  isEnabled: boolean;
  isTextArea?: boolean;
}

export const SimpleInput: React.FC<SimpleInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  isEnabled,
  isTextArea = false
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-xs 3xl:text-sm font-semibold text-slate-700">
        {label}
      </label>
      {isTextArea ? (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={!isEnabled}
          className={`
            w-full px-3 py-2 text-xs 3xl:text-sm placeholder:text-[11px] 3xl:placeholder:text-xs border border-slate-300 rounded-lg text-slate-900 resize-none
            focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300
            ${isEnabled ? '' : 'bg-gray-50 text-gray-500 cursor-not-allowed'}
          `}
          rows={4}
        />
      ) : (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={!isEnabled}
          className={`
            w-full px-3 py-2 text-xs 3xl:text-sm placeholder:text-[11px] 3xl:placeholder:text-xs border border-slate-300 rounded-lg text-slate-900
            focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300
            ${isEnabled ? '' : 'bg-gray-50 text-gray-500 cursor-not-allowed'}
          `}
        />
      )}
    </div>
  );
};
